var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 24.832V2.08203C16.2668 2.08203 19.1601 3.28047 21.2933 5.41369C23.4266 7.54692 24.625 10.4402 24.625 13.457C24.625 16.4739 23.4266 19.3671 21.2933 21.5004C19.1601 23.6336 16.2668 24.832 13.25 24.832ZM13.25 26.457C9.80219 26.457 6.49558 25.0874 4.05761 22.6494C1.61964 20.2114 0.25 16.9048 0.25 13.457C0.25 10.0092 1.61964 6.70262 4.05761 4.26464C6.49558 1.82667 9.80219 0.457031 13.25 0.457031C16.6978 0.457031 20.0044 1.82667 22.4424 4.26464C24.8804 6.70262 26.25 10.0092 26.25 13.457C26.25 16.9048 24.8804 20.2114 22.4424 22.6494C20.0044 25.0874 16.6978 26.457 13.25 26.457Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabImg);
export default __webpack_public_path__ + "static/media/tabImg.f28f2c63fb930401760726f367d386ec.svg";
export { ForwardRef as ReactComponent };